/* eslint-disable class-methods-use-this */
import requireAll from '../utils/require-all'

class SVGLoader {
  constructor(url, loadIcons = true) {
    this.svgUrl = url
    if (loadIcons) {
      this.loadSpriteIcons()
    }
    this.svgLoader()
  }

  loadSpriteIcons() {
    requireAll(require.context('./../../icons/', true, /\.svg$/))
  }

  svgSuccess(e) {
    const oThis = e.target || e.currentTarget

    if (oThis.status.toString() !== '404') {
      const div = document.createElement('div')
      div.className = 'svg-loader-placeholder'
      div.innerHTML = oThis.responseText
      div.style.display = 'none'
      document.body.appendChild(div)
    }
  }

  svgError(e) {
    // eslint-disable-next-line no-console
    console.error(`SVG Load Error: ${e.message}`)
  }

  svgLoader() {
    const xhr = new XMLHttpRequest()
    xhr.onload = this.svgSuccess
    xhr.onerror = this.svgError
    xhr.open('get', this.svgUrl, true)
    xhr.send()
  }
}

const SVGSpriteInit = {
  init(loadIcons = true) {
    const { path } = window.sapiens
    window.SVG = new SVGLoader(`${path}/build/icons.svg`, loadIcons)
  },
}

export default SVGSpriteInit
